module.exports = __webpack_public_path__ + "img/1.defad56c.png";